if (typeof window.tagalysReady === 'undefined') {
  window.tagalysReady = false
  document.addEventListener('tagalysReady', () => {
    window.tagalysReady = true
  })
}

class RecommendedForYou extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.handleTagalysReady = this.buildProductCards.bind(this)
    this.timeoutId = null
  }

  connectedCallback () {
    this.unhideSection()
    if (window.tagalysReady) {
      this.buildProductCards()
    } else {
      this.setupListeners()
      this.startTagalysEventTimeout()
    }
  }

  disconnectedCallback () {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
    document.removeEventListener('tagalysReady', this.handleTagalysReady)
  }

  setupListeners () {
    this.handleTagalysReady = this.buildProductCards.bind(this)
    document.addEventListener('tagalysReady', this.handleTagalysReady)
  }

  /**
   * Build product cards
   */
  async buildProductCards () {
    if (!this.dataset.tagalysSmartWidgetId) {
      console.error('tagalysSmartWidgetId missing')
      this.hideSection()
      return
    }

    let productRecsData = false
    try {
      productRecsData = await this.fetchProductData()
    } catch (error) {
      console.error('Error fetching product data:', error)
    }

    if (
      !productRecsData ||
      !productRecsData.products ||
      !productRecsData.products > 0 ||
      productRecsData.status === 'Not found'
    ) {
      console.error('Removing section: No product data found')
      this.hideSection()
    } else {
      const productHandles = Object.values(productRecsData.products).map(
        product => product.handle,
      )
      this.buildProducts(productHandles)
    }
  }

  async fetchProductData () {
    return new Promise((resolve, reject) => {
      window.Tagalys.APIConnector.Recommendations.call({
        params: {
          recommendationId: this.dataset.tagalysSmartWidgetId,
          productId: this.dataset.productId,
          limit: this.dataset.productLimit || 4,
        },
        onSuccess (response) {
          resolve(response)
        },
        onFailure (response) {
          console.error('Tagalys API error:', response)
          reject(response)
        },
      })
    })
  }

  /**
   * Build Products
   */
  async buildProducts (productHandles = []) {
    let productsMarkupString = ''

    if (!productHandles || !productHandles.length >= 1) {
      console.error(
        'Attempted to build products but failed due to missing data',
      )
      return
    }

    try {
      const fetchPromises = productHandles.map(async handle => {
        const url = `/products/${handle}?${new URLSearchParams({
          view: 'recommendedcard',
        }).toString()}`
        return this.fetchProductCardMarkup(url)
      })

      const productCardMarkups = await Promise.all(fetchPromises)

      productCardMarkups.forEach(markup => {
        if (markup) {
          productsMarkupString += `
            <div class="prd-RecForYou_Product">
              ${markup}
            </div>
          `
        }
      })

      this.innerHTML = productsMarkupString
      this.unhideSection()
    } catch (error) {
      console.error('Error building products:', error)
    }
  }

  async fetchProductCardMarkup (url) {
    try {
      const response = await fetch(url)
      return await response.text()
    } catch (error) {
      console.error(error)
      return undefined
    }
  }

  startTagalysEventTimeout () {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
    this.timeoutId = setTimeout(() => {
      console.error('Tagalys event timeout')
      this.hideSection()
      this.timeoutId = null
    }, 10000)

    const eventListener = () => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
      document.removeEventListener('tagalysReady', eventListener)
    }
    document.addEventListener('tagalysReady', eventListener)
  }

  hideSection () {
    if (!this.section) return

    this.section.style.display = 'none'
  }

  unhideSection () {
    if (!this.section) return

    this.section.style.display = 'block'
  }

  get section () {
    return document.querySelector(
      '[data-section-type="product-recommended-for-you"]',
    )
  }
}

if (!customElements.get('recommended-for-you')) {
  customElements.define('recommended-for-you', RecommendedForYou)
}
